export const PRODUCT_COL_GROW = 1;
export const INPUT_COL_GROW = 0;
export const INPUT_COL_BASIC = 120;
export const VARIANTS_COL_BASIC = 200;
export const ACTIONS_COL_BASIC = 136;
export const MAX_ENTRIES = 10;
